import CurrencyInput from "react-currency-input-field";

export const NumberInput = (props) => {
    return (
      <CurrencyInput
        name="number"
        decimalsLimit={2}
        allowNegativeValue={false}
        allowDecimals={props.allowDecimals || false}
        decimalSeparator=","
        groupSeparator="."
        onValueChange={(value) =>
          props.onChange(value)
        }
        {...props}
      />
    );
  };


export const fromStringToNumber = (value) =>{
    return Number(String(value).replace(',', '.'))
}